<template>
  <div :class="{'modal':true, 'is-active':show}">
    <div class="modal-background" @click="$emit('close-modal')"></div>
    <div class="modal-card">
      <form name="registerForm" @submit.prevent="handleRegister">
        <header class="modal-card-head back-gradient-animation">
          <p class="modal-card-title has-text-white has-text-centered">Regístrate</p>
          <button class="delete" aria-label="close" @click="$emit('close-modal')" type="button" :disabled="submitted"></button>
        </header>
        <section class="modal-card-body">
          <!-- USERNAME -->
          <div class="field">
            <p class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="text"
                placeholder="Nombre de usuario"
                name="usuario"
                id="id_username"
                v-model="user.username"
                v-validate="'required|max:10'"
                maxlength="10"
              />

              <span class="icon is-small is-left">
                <fa icon="id-card-alt" />
              </span>
            </p>
            <p class="help is-danger" v-if="errors.has('usuario')">Debe escribir un nombre de usuario para su cuenta. (Max. 10 caracteres)</p>
            <p class="help">El nombre de usuario puede tener hasta 10 caracteres.</p>
          </div>
          <!-- USERNAME/ -->
          <!-- EMAIL -->
        <div class="field">
        <div class="control has-icons-left has-icons-right">
            <input class="input" 
                name="email"
                type="email" 
                v-model="user.email"
                placeholder="Correo electrónico"
                v-validate="'required|email'">
            <span class="icon is-small is-left">
                <fa icon="envelope" />  
            </span>
        </div>
        <p class="help is-danger" v-if="errors.has('email')">{{ errors.first('email') }}</p>
        </div>
          <!-- /EMAIL -->
          <hr>
          <!-- PERSONAL -->

        <div class="field is-horizontal">
        <div class="field-body">
            <div class="field">
            <p class="control is-expanded has-icons-left">
                <input class="input" 
                    type="text" 
                    placeholder="Nombre"
                    name="first_name"
                    v-model="user.first_name"
                    v-validate="'required|max:10'"
                    maxlength="10">
                <span class="icon is-small is-left">
                    <fa icon="user" />
                </span>
            </p>
            <p class="help is-danger" v-if="errors.has('first_name')">El campo con su nombre no puede quedar vacio. (Max. 10 caracteres)</p>
            </div>
            <div class="field">
            <p class="control is-expanded has-icons-left has-icons-right">
                <input class="input" 
                    type="text" 
                    placeholder="Apellido"
                    name="last_name"
                    v-model="user.last_name"
                    v-validate="'required'">
                <span class="icon is-small is-left">
                    <fa icon="user" />
                </span>
            </p>
            <p class="help is-danger" v-if="errors.has('last_name')">El campo con su apellido no puede quedar vacio.</p>
            </div>
        </div>
        </div>
          <!-- /PERSONAL -->
          <hr>
          <!-- PASSWORD -->
          <div class="field">
            <div class="control">
              <div class="field has-addons">
                <p class="control has-icons-left is-expanded">
                  <input
                    class="input"
                    :type="hidePassword ? 'password':'text'"
                    placeholder="Contraseña"
                    name="contraseña"
                    ref="contraseña"
                    id="id_password"
                    v-model="user.password"
                    v-validate="'required|min:8|max:10'"
                    maxlength="10"
                  />

                  <span class="icon is-small is-left">
                    <fa icon="key" />
                  </span>
                </p>
                <p class="control" @click="hidePassword=!hidePassword">
                  <a class="button is-static">
                    <fa :icon="hidePassword?'eye-slash':'eye'" />
                  </a>
                </p>
              </div>
            </div>
            <p class="help is-danger" v-if="errors.has('contraseña')">{{ errors.first('contraseña') }}</p>
          </div>
          <div class="field">
            <div class="control">
              <div class="field has-addons">
                <p class="control has-icons-left is-expanded">
                  <input
                    class="input"
                    :type="hidePassword2 ? 'password':'text'"
                    placeholder="Repita su contraseña"
                    name="repetir"
                    id="id_re_password"
                    v-model="user.re_password"
                    maxlength="10"
                    v-validate="'required|confirmed:contraseña'"
                  />

                  <span class="icon is-small is-left">
                    <fa icon="key" />
                  </span>
                </p>
                <p class="control" @click="hidePassword2=!hidePassword2">
                  <a class="button is-static">
                    <fa :icon="hidePassword2?'eye-slash':'eye'" />
                  </a>
                </p>
              </div>
            </div>
            <p class="help is-danger" v-if="errors.has('repetir')">{{ errors.first('repetir') }}</p>
          </div>
          <p class="help">La contraseña debe tener entre 8 y 10 caracteres.</p>
          <!-- PASSWORD/ -->
        </section>
        <footer class="modal-card-foot back-gradient-animation">
          <div class="buttons has-addons is-right">
            <button class="button is-success is-inverted is-outlined" :disabled="submitted" @click="$emit('close-modal')" type="button">Cancelar</button>
            <button :class="{'button is-success is-light':true, 'is-loading':submitted}" :disabled="submitted" type="submit">Proceder</button>
          </div>
        </footer>
      </form>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import User from "../models/user";
export default {
  name: "Login",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    user: new User("", ""),
    hidePassword: true,
    hidePassword2:true,
    submitted: false
  }),
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  methods: {
    handleRegister() {
      this.message = '';
      this.$validator.validate().then(isValid => {
        if (isValid) {
            this.submitted = true;
            Swal.fire({
              position: 'top',
              icon: 'success',
              title: '¡Tu cuenta ha sido creada satisfactoriamente!',
              showConfirmButton: false,
              timer: 2500
            }).then(()=>{
              this.$emit('close-modal', {})
              this.submitted = false
            })
          // this.submitted = true;
          // this.$store.commit('setLoader', true)
          // this.$store.dispatch('auth/register', this.user).then(
          //   data => {
          //     this.$store.commit('setLoader', false)
          //     Swal.fire({
          //       position: 'top',
          //       icon: 'success',
          //       title: '¡Tu cuenta ha sido creada satisfactoriamente!',
          //       showConfirmButton: false,
          //       timer: 2500
          //     }).then(()=>{
          //       this.$emit('close-modal', data)
          //       this.submitted = false
          //     })
          //   },
          //   error => {
          //     var thisError = error.response.data
          //     if ('username' in thisError) {
          //       Swal.fire({
          //         icon: 'warning',
          //         title: 'El nombre de Usuario ya existe.',
          //       }).then(()=>{
          //         this.user.username = ''
          //       })
          //     } else if('email' in thisError) {
          //       Swal.fire({
          //         icon: 'warning',
          //         title: 'El correo electrónico ya existe.',
          //       }).then(()=>{
          //         this.user.email = ''
          //       })
          //     } else if ('password1' in thisError){
          //       Swal.fire({
          //         icon: 'warning',
          //         title: 'La contraseña es muy común, intente colocando letras y números.',
          //       }).then(()=>{
          //         this.user.password = ''
          //         this.user.re_password = ''
          //       })  
          //     } else {
          //       Swal.fire({
          //         icon: 'error',
          //         title: 'Oops... ¡Algo ha salido mal!',
          //         text: 'No se ha podido crear la cuenta.'
          //       })
          //     }

          //     this.$store.commit('setLoader', false)
          //     this.submitted = false
          //   }
          // );
        }
      });
    }
  }
};
</script>

<style scoped>
@media screen and (min-width: 769px){
    .modal-content, .modal-card {
        width: 420px;
    }
}
@media screen and (max-width: 769px){
    .modal-content, .modal-card {
        width: 90%;
    }
    .modal-card-body {
      overflow-y: auto !important;
      max-height: calc(100vh - 230px) !important;;
    }
}
.buttons {
  width: 100%;
}
.back-gradient-animation {
  background: linear-gradient(-45deg, #4E8878, #224F5E, #E9D362, #333333);
  background-size: 400% 400%;
  animation: gradient 15s ease infinite;
}

@keyframes gradient {
	0% {
		background-position: 0% 50%;
	}
	50% {
		background-position: 100% 50%;
	}
	100% {
		background-position: 0% 50%;
	}
}
</style>
